<template>
  <div style="width: 100%">
    <v-row>
      <v-col>
        <v-row>
          <h2 class="title primary--text text--darken-1 text-no-wrap mt-0 ml-2">
            DADOS PESSOAIS
          </h2>
        </v-row>
        <v-row>
          <!-- foto -->
          <v-col
            class="d-flex flex-column align-center"
            cols="12"
            md="4"
          >
            <v-avatar size="220px">
              <img
                :src="imagemPreview"
                alt="Imagem do Perfil"
              >
            </v-avatar>
          </v-col>

          <v-col
            cols="12"
            md="8"
          >
            <!-- nome civil -->
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model.trim="usuario.nomeCivil"
                  color="primary"
                  disabled
                  label="Nome"
                  prepend-icon="assignment_ind"
                  tabindex="1"
                />
              </v-col>
            </v-row>

            <!-- nome social -->
            <v-row
              class="mt-4"
              dense
            >
              <v-col
                cols="12"
                md="8"
                sm="8"
              >
                <v-card flat>
                  <v-card-text>
                    <h4>
                      Utiliza nome social?
                      <v-tooltip
                        top
                        max-width="500"
                      >
                        <template v-slot:activator="{ on }">
                          <v-icon v-on="on">
                            help
                          </v-icon>
                        </template>
                        <span>{{ tooltipNomeSocial }}</span>
                      </v-tooltip>
                    </h4>
                    <v-radio-group
                      v-model="perfilUpdate.temNomeSocial"
                      row
                      @change="temNomeSocial"
                    >
                      <v-radio
                        :value="true"
                        label="Sim"
                      />
                      <v-radio
                        :value="false"
                        label="Não"
                      />
                    </v-radio-group>
                    <v-text-field
                      v-if="perfilUpdate.temNomeSocial"
                      id="textfieldNomeSocial"
                      ref="textfieldNomeSocial"
                      v-model="perfilUpdate.nomeSocial"
                      :rules="[(v) => !!v || 'Nome social obrigatório']"
                      autofocus
                      color="primary"
                      label="Nome Social"
                      prepend-icon="assignment_ind"
                      required
                      tabindex="1"
                      @blur="nomeSocialVazio"
                      @keyup="uppercase"
                    >
                      <template v-slot:append>
                        <v-btn
                          v-if="perfil.nomeSocial !== perfilUpdate.nomeSocial"
                          text
                          color="secondary"
                          small
                          @click="updatePerfil"
                        >
                          Salvar
                          <v-icon
                            class="ml-1"
                            small
                          >
                            check
                          </v-icon>
                        </v-btn>
                        <v-btn
                          v-if="perfil.nomeSocial !== perfilUpdate.nomeSocial"
                          text
                          color="warning"
                          small
                          @click="perfilUpdate.nomeSocial = perfil.nomeSocial"
                        >
                          Desfazer
                          <v-icon
                            class="ml-1"
                            small
                          >
                            undo
                          </v-icon>
                        </v-btn>
                      </template>
                    </v-text-field>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>

            <!-- condição de deficiência -->
            <v-row
              class="mt-4"
              dense
            >
              <v-col
                cols="12"
                md="8"
                sm="8"
              >
                <v-card flat>
                  <v-card-text>
                    <h4>Você possui alguma condição de deficiência?</h4>
                    <v-radio-group
                      v-model="perfilUpdate.deficiente"
                      row
                      @change="temDeficiencia"
                    >
                      <v-radio
                        :value="true"
                        label="Sim"
                      />
                      <v-radio
                        :value="false"
                        label="Não"
                      />
                    </v-radio-group>
                    <v-autocomplete
                      v-if="perfilUpdate.deficiente"
                      v-model="perfilUpdate.deficiencias"
                      :items="deficiencias"
                      :rules="[
                        () =>
                          perfilUpdate.deficiencias.length > 0 ||
                          `Informe pelo menos uma condição`,
                      ]"
                      :search-input.sync="deficienciaSearch"
                      autofocus
                      chips
                      color="primary"
                      deletable-chips
                      item-text="nome"
                      label="Qual condição?"
                      placeholder="Digite para pesquisar..."
                      multiple
                      prepend-icon="accessible"
                      required
                      return-object
                      @change="
                        updatePerfil();
                        deficienciaSearch = '';
                      "
                    >
                      <template v-slot:selection="data">
                        <v-chip
                          :input-value="data.selected"
                          class="chip--select-multi"
                          close
                          color="secondary"
                          search=""
                          small
                          text-color="white"
                          @click:close="removeDeficiencia(data.item)"
                        >
                          {{ data.item.nome }}
                        </v-chip>
                      </template>
                    </v-autocomplete>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row
          v-if="perfilUpdate.deficiente && perfilUpdate.deficiencias.length > 0"
        >
          <v-textarea
            v-model="perfilUpdate.observacoesDeficiencias"
            auto-grow
            label="Tendo em vista a sua condição, como seria um ambiente de trabalho adaptado às suas necessidades?"
            name="input-4-1"
            prepend-icon="settings_accessibility"
            rows="2"
            @keydown.enter.prevent="updatePerfil"
          >
            <template v-slot:append>
              <v-btn
                v-if="
                  perfil.observacoesDeficiencias !==
                    perfilUpdate.observacoesDeficiencias
                "
                text
                color="secondary"
                small
                @click="updatePerfil"
              >
                Salvar
                <v-icon
                  class="ml-1"
                  small
                >
                  check
                </v-icon>
              </v-btn>
              <v-btn
                v-if="
                  perfil.observacoesDeficiencias !==
                    perfilUpdate.observacoesDeficiencias
                "
                text
                color="warning"
                small
                @click="
                  perfilUpdate.observacoesDeficiencias =
                    perfil.observacoesDeficiencias
                "
              >
                Desfazer
                <v-icon
                  class="ml-1"
                  small
                >
                  undo
                </v-icon>
              </v-btn>
            </template>
          </v-textarea>
        </v-row>

        <v-row>
          <h2 class="title primary--text text--darken-1 text-no-wrap mt-4 ml-2">
            DADOS PROFISSIONAIS
          </h2>
        </v-row>

        <v-row>
          <!-- siape -->
          <v-col
            cols="12"
            lg="6"
            md="6"
          >
            <v-text-field
              v-model.trim="usuario.siape"
              color="primary"
              disabled
              label="N° SIAPE"
              prepend-icon="pin"
            />
          </v-col>

          <!-- email -->
          <v-col
            cols="12"
            lg="6"
            md="6"
          >
            <v-text-field
              v-model.trim="usuario.email"
              color="primary"
              disabled
              label="E-mail"
              prepend-icon="alternate_email"
            />
          </v-col>

          <!-- cargo -->
          <v-col
            cols="12"
            lg="6"
            md="6"
          >
            <v-text-field
              v-model.trim="usuario.cargo"
              color="primary"
              disabled
              label="Cargo"
              prepend-icon="engineering"
            />
          </v-col>

          <!-- unidade de exercício -->
          <v-col
            cols="12"
            lg="6"
            md="6"
          >
            <v-text-field
              v-model.trim="unidade.nome"
              color="primary"
              disabled
              label="Unidade de Exercício"
              prepend-icon="account_balance"
            />
          </v-col>

          <!-- unidade pai da unidade de exercício -->
          <v-col
            v-if="unidadePai"
            cols="12"
            lg="6"
            md="6"
          >
            <v-text-field
              v-model.trim="unidadePai.nome"
              color="primary"
              disabled
              label="Unidade Superior"
              prepend-icon="account_balance"
            />
          </v-col>

          <!-- função -->
          <v-col
            cols="12"
            lg="6"
            md="6"
          >
            <v-text-field
              v-model.trim="funcao"
              color="primary"
              disabled
              label="Função"
              prepend-icon="badge"
            />
          </v-col>

          <!-- contato -->
          <v-col
            cols="12"
            lg="4"
            md="6"
          >
            <v-text-field
              v-model.trim="usuario.contato"
              color="primary"
              disabled
              label="Contato"
              prepend-icon="phone"
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { DEFAULT_IMAGEM_PERFIL } from '@/modules/var';

export default {
  name: 'Cadastro',

  props: {
    perfil: {
      type: Object,
      default: () => ({}),
      required: true,
    },
  },

  data() {
    return {
      deficienciaSearch: '',
      perfilUpdate: {},
      imagemPreview: '',
    };
  },

  computed: {
    ...mapState({
      deficiencias: (state) => state.perfil.deficiencias,
      usuario: (state) => state.auth.usuario,
      unidade: (state) => state.auth.unidade,
      unidadePai: (state) => state.auth.unidadePai,
      chefia: (state) => state.auth.chefia,
    }),
    funcao() {
      return this.usuario.funcao ? this.usuario.funcao : 'SEM FUNÇÃO GRATIFICADA';
    },
    tooltipNomeSocial() {
      return (
        'Nome Social - designação pela qual a pessoa travesti ou transexual se identifica e é socialmente '
        + 'reconhecida (Inciso I, do Art. 1º do Decreto 8727, de 28/04/2016).'
      );
    },
  },

  watch: {
    perfil(value) {
      this.perfilUpdate = { ...value };
    },
  },

  created() {
    this.imagemPreview = DEFAULT_IMAGEM_PERFIL;
    this.perfilUpdate = { ...this.perfil };
  },

  methods: {
    updatePerfil() {
      if (this.perfilUpdate.temNomeSocial && (!this.perfilUpdate.nomeSocial || this.perfilUpdate.nomeSocial === '')) {
        this.perfilUpdate.temNomeSocial = false;
      }

      if (this.perfilUpdate.temNomeSocial) {
        this.perfilUpdate.nomeSocial = this.perfilUpdate.nomeSocial.trim();
      }

      if (this.perfilUpdate.deficiente && this.perfilUpdate.deficiencias.length <= 0) {
        this.perfilUpdate.deficiente = false;
      }
      this.$emit('updatePerfil', this.perfilUpdate);
    },
    temNomeSocial(value) {
      if (!value) {
        this.updatePerfil();
      }
    },
    temDeficiencia(value) {
      if (!value) {
        this.updatePerfil();
      }
    },
    removeDeficiencia(item) {
      if (item.id) {
        const index = this.perfilUpdate.deficiencias.findIndex((a) => a.id === item.id);
        if (index !== -1) {
          this.perfilUpdate.deficiencias.splice(index, 1);
          this.updatePerfil();
        }
      }
    },
    uppercase() {
      const elem = document.getElementById('textfieldNomeSocial');
      const startPos = elem.selectionStart;
      const endPos = elem.selectionEnd;
      elem.value = elem.value.toUpperCase();
      elem.setSelectionRange(startPos, endPos);
    },
    nomeSocialVazio() {
      if (this.$refs.textfieldNomeSocial) {
        if (this.perfilUpdate.nomeSocial === '' || this.perfilUpdate.nomeSocial == null) {
          this.$refs.textfieldNomeSocial.focus();
        }
      }
    },
  },
};
</script>
